export class QuestUser {
  id?: number;
  email: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  isSuperUser?: boolean;
}
